/**
 * Best-effort suggestion for a duplicated record number: increments the last
 * numeric group found in the source number (keeping its zero-padding), e.g.
 * "2024.1.5" -> "2024.1.6", "INV045" -> "INV046". Falls back to appending
 * " - copie" when the source has no trailing number, and returns "" for an
 * empty source.
 */
export const incrementRecordNumber = (source: string | undefined): string => {
  const value = (source ?? "").trim();
  if (!value) return "";
  const match = value.match(/(\d+)(\D*)$/);
  if (!match || match.index === undefined) return `${value} - copie`;
  const [, digits, suffix] = match;
  const next = (BigInt(digits) + 1n).toString().padStart(digits.length, "0");
  return `${value.slice(0, match.index)}${next}${suffix}`;
};
